import { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
import { api } from "../lib/api";
import { useT } from "../i18n";

const FLAG = { FR: "FR", PT: "PT", ES: "ES", DE: "DE" };

export const CityAutocomplete = ({ value, onSelect, testId = "city-input", required = false }) => {
  const { t } = useT();
  const [q, setQ] = useState(value || "");
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);

  useEffect(() => { setQ(value || ""); }, [value]);

  const search = (text) => {
    setQ(text);
    onSelect({ city: text.trim(), city_country: null, city_lat: null, city_lon: null });
    clearTimeout(timer.current);
    if (text.trim().length < 2) return setItems([]);
    timer.current = setTimeout(() => {
      api.get("/cities/search", { params: { q: text } }).then((r) => { setItems(r.data); setOpen(true); }).catch(() => setItems([]));
    }, 180);
  };

  const choose = (c) => {
    setQ(c.name);
    setItems([]);
    setOpen(false);
    onSelect({ city: c.name, city_country: c.country, city_lat: c.lat, city_lon: c.lon });
  };

  return (
    <div className="relative">
      <input data-testid={testId} className="field" placeholder={t("city_placeholder")} value={q} required={required} autoComplete="off"
        onChange={(e) => search(e.target.value)} onFocus={() => items.length && setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && q.trim().length >= 2 && (
        <ul className="panel absolute inset-x-0 top-full z-20 mt-1 max-h-64 overflow-y-auto shadow-xl" data-testid={`${testId}-list`}>
          {items.length === 0 && <li className="px-4 py-3 text-sm text-rox-muted">{t("city_no_result")}</li>}
          {items.map((c) => (
            <li key={`${c.name}-${c.postal}-${c.lat}`}>
              <button type="button" data-testid={`${testId}-option`} onMouseDown={() => choose(c)} className="flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm hover:bg-rox-black">
                <MapPin size={14} className="shrink-0 text-rox-orange" />
                <span className="flex-1 truncate">{c.name}</span>
                <span className="shrink-0 text-[11px] uppercase tracking-wider text-rox-muted">{c.postal ? `${c.postal} · ` : c.admin ? `${c.admin} · ` : ""}{FLAG[c.country] || c.country}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
